angular.module('ihestiaCommonDirectives.configHelper', []);